import { MenuDropdown } from './MenuDropdown'
import { MenuListItem, MenuListButton } from './MenuListItem'
import { useSession } from '../context/session'
import { useCallback, type ReactNode } from 'react'

import { useNavigate } from '@tanstack/react-router'

const AuthNav = ({ children }: { children: ReactNode }) => {
  const navigate = useNavigate()

  const { user } = useSession()

  return user ? (
    <>{children}</>
  ) : (
    <MenuListButton
      onClick={async () => await navigate({ to: '/auth/login' })}
      title="Login"
    />
  )
}

const LogoutButton = () => {
  const { signOut } = useSession()
  const navigate = useNavigate()

  const handleSignout = useCallback(async () => {
    await signOut()
    navigate({ to: '/auth/login' })
  }, [signOut, navigate])

  return <MenuListButton onClick={handleSignout} title="Logout" />
}

export const Navigation = () => {
  return (
    <div className="heading bg-white">
      <div className="xs:flex-col container mx-auto items-center px-2 sm:flex md:justify-between xl:justify-start">
        <img
          width={400}
          height={133.3}
          src="/images/ser-un-logo.svg"
          alt="SER logo"
        />
        <h1 className="ml-2 font-serif text-4xl xl:ml-24">
          Seed Information Database
        </h1>
      </div>
      <div className="bg-serblue-light uppercase text-white">
        <div className="container mx-auto px-2 flex justify-between ">
          <ul className="flex list-none overflow-y-visible text-sm align-middle">
            <MenuListItem linkUrl="/" title="Search" />
            <MenuListItem linkUrl="/about" title="About" />
            <MenuDropdown
              title="Definitions"
              items={[
                {
                  title: 'Storage Behaviour',
                  url: '/definitions/storage',
                },
                {
                  title: 'Seed Weights',
                  url: '/definitions/seed-weights',
                },
                { title: 'Dispersal', url: '/definitions/dispersal' },
                {
                  title: 'Germination',
                  url: '/definitions/germination',
                },
                {
                  title: 'Morphology',
                  url: '/definitions/morphology',
                },
              ]}
            />
            <MenuDropdown
              title="Viability Calculators"
              items={[
                {
                  title: 'Storage time',
                  url: '/viability/storage-time',
                },
                {
                  title: 'Final viability',
                  url: '/viability/final-viability',
                },
                {
                  title: 'Predict days to lose one probit',
                  url: '/viability/lose-one-probit-days',
                },
                {
                  title: 'Equilibrium moisture content',
                  url: '/viability/moisture-equilibrium',
                },
              ]}
            />
          </ul>
          <ul>
            <AuthNav>
              <MenuListItem linkUrl="/private/upload" title="Upload" />
              <LogoutButton />
            </AuthNav>
          </ul>
        </div>
      </div>
    </div>
  )
}
